export enum AudienceExperienceStatusEnum {
    DISABLED = 0,
    RELEVANT = 1,
    NOT_RELEVANT = 2,
}
